export default [
    {
        path: '/platinum/navigations',
        props: true,
        component: () => import('@/views/PlatinumNavigation'),
    },
];
